import styled from 'styled-components';

export const TagsContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;

  button {
    display: flex !important;
    margin: 0;
    margin-right: 4px;
    margin-bottom: 5px;
    padding: 2px 15px 3px;
  }

  button ~ span {
    margin-top: -8px;
  }

  .selected-tag {
    line-height: 20px;
    margin-bottom: 5px;
    div {
      margin: 0;
      margin-right: 4px;
      padding: 3px 0px 6px 10px;

      span {
        top: 1px;
      }
    }
  }

  [data-tooltipped] {
    padding: 0 !important;
    display: block !important;
  }

  .more-tags {
    background: #ebeff3;
    border-radius: 4px;
    padding: 6px 10px;
    font-weight: 500;
    font-size: 14px;
  }

  .default-loader {
    width: auto;
    margin-top: -4px;
  }
`;
export const MenuContainer = styled.div`
  background: #ffffff;
  min-height: 90px;
  max-height: 300px;
  width: 220px;
  position: absolute;
  left: 0;
  top: 5px;
  z-index: 15;
  display: flex;
  flex-direction: column;
  border-radius: 6px;
  box-shadow: rgb(0 0 0 / 6%) 0px 2px 3px, rgb(25 50 71 / 16%) 0px 4px 20px;

  .menu-content {
    padding: 0 8px;
    overflow: auto;
    height: 100%;
    max-height: 200px;
    min-height: 50px;

    .menu-item {
      width: 100%;
      cursor: pointer;
      outline: none;
      color: rgb(18, 52, 77);
      border-radius: 4px;
      padding: 8px;
      font-size: 14px;
      word-break: break-word;
      margin-bottom: 5px;
      &:hover {
        background-color: var(--bg-info);
      }
    }

    .default-content {
      width: 100%;
      padding: 8px;
      font-size: 14px;

      &.error {
        color: var(--color-persimmon-800);
        font-size: 13px;
        padding-top: 2px;
      }
    }
  }
  .header {
    padding: 8px;
    input {
      padding-left: 4px;
      width: 100%;
    }
  }

  .link {
    padding: 8px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    color: var(--text-link);

    &:hover {
      background-color: var(--bg-info);
      border-radius: 4px;
    }
  }

  .empty-placeholder {
    font-size: 12px;
    font-weight: 500;
    color: var(--color-smoke-700);
    padding: 10px;
  }
  .menu-footer {
    padding: 6px 8px;
  }
`;
